export const GET_REWARD_LIST = "GET_REWARD_LIST";
export const GET_REWARD_HISTORY_LIST = "GET_REWARD_HISTORY_LIST";
export const ADD_REWARD = "ADD_REWARD";
export const UPDATE_REWARD = "UPDATE_REWARD";
export const DELETE_REWARD = "DELETE_REWARD";
export const EXPORT_REWARD_HISTORY = "EXPORT_REWARD_HISTORY";
